module.exports = {
  listActivityTypes: function () {
    return this.client.get(`/v${this.v}/activity_type/`)
  },
}



// WEBPACK FOOTER //
// ./shared/mapmy/activityTypes.js